<template>
  <div>
    <div class="mb-2">
      <b-button size="sm" variant="info" @click="downloadCsvSelected" class="mr-1" :disabled="selectedTokensLemmas.length == 0">
        Download Selected Occurrences (.csv)
      </b-button>
    </div>
    <div class="mb-5">

      <div class="mb-2">
        <b-button size="sm" variant="primary" @click="selectAll" class="mr-1">
          Select all
        </b-button>

        <b-button size="sm" variant="primary" @click="deselectAll" class="mr-1">
          Deselect all
        </b-button>

        <b-button size="sm" variant="primary" @click="biselectVisible('select')" class="mr-1">
          Select visible
        </b-button>

        <b-button size="sm" variant="primary" @click="biselectVisible('deselect')" class="">
          Deselect visible
        </b-button>
      </div>

       <span v-if="config.editable">
        <b-button size="sm" variant="secondary" v-b-modal.modal-lemmatize class="mr-1" :disabled="selectedTokensLemmas.length == 0">
          + Lemma
        </b-button>
        <b-button size="sm" variant="danger" class="mr-2" v-b-modal.modal-lemma :disabled="Object.keys(selectedLemmata).length == 0">
          Remove Lemma
        </b-button>
        <b-button size="sm" variant="secondary" v-b-modal.modal-tagging class="mr-1" :disabled="selectedTokensLemmas.length == 0">
          + HCC
        </b-button>
        <b-button size="sm" variant="secondary" v-b-modal.modal-tagging-replace class="mr-1" :disabled="selectedTokensLemmas.length == 0" v-if="hcc">
          Replace HCC
        </b-button>
        <b-button size="sm" variant="danger" class="mr-2" v-b-modal.modal-hcc :disabled="Object.keys(selectedHCCs).length == 0">
          Remove HCC(s)
        </b-button>
      </span>
      <span class="ml-2 mt-2">Selected {{ selectedTokensLemmas.length }} tokens</span>

    </div>
    <table class="table compact hover" id="datatable-results">
      <thead>
        <tr class="filtering">
          <th v-for="(column, index) in columns" :key="`datatable-results-th-filter-${column.key}`" :style=" index < 5 ? 'position: sticky;left: 0;' : ''">
            <input
              v-if="column.searchable"
              v-model="filters[index]"
              type="text"
              class="form-control form-control-sm"
              :placeholder="column.name"
            />
            <span v-html="column.name"></span>
          </th>
        </tr>
      </thead>
      <tbody>
      </tbody>
    </table>

    <b-modal
      centered
      id="modal-tagging"
      title="Tagging"
      size="xl"
      @ok="assignTokensToHCC"
    >
      <HCCAutocomplete ref="hccRef" />
    </b-modal>

    <b-modal
      centered
      id="modal-tagging-replace"
      title="Tagging"
      size="xl"
      @ok="replaceHCC"
      v-if="hcc"
    >
      <HCCAutocomplete ref="hccRefReplace" :head="hcc.head" />
    </b-modal>

    <b-modal
      centered
      id="modal-lemmatize"
      title="Lemmatize"
      size="lg"
      @ok="assignTokensToLemma"
    >
      <LemmaSelect ref="lemmaSelectRef" />
    </b-modal>

    <div class="hcc-float" v-if="config.editable">
      <b-modal
        id="modal-hcc"
        title="Select HCCs to remove"
        ok-title="remove"
        size="md"
        @ok="removeTag"
      >
        Click on a HCC to discard it from the HCCs to be removed from the tokens (i.e. only HCCs visible in this dialog will be removed). <br /><br />
        <b-badge href="#"
          variant="info"
          class="mr-1"
          v-for="hcc in selectedHCCs"
          :key="'modal-22-' + hcc.hcc_id"
          @click="removeSelected(hcc)"
        >
          <span v-html="hcc.shortname"></span>
          <!-- <b-icon icon="trash" aria-hidden="true" class="ml-1"></b-icon> -->
        </b-badge>
      </b-modal>
    </div>

    <div class="lemma-float" v-if="config.editable">
      <b-modal
        id="modal-lemma"
        title="Select Lemma(s) to remove"
        ok-title="remove"
        size="md"
        @ok="removeLemma"
      >
        Click on a Lemma to discard it from the Lemmata to be removed from the tokens (i.e. only Lemmata visible in this dialog will be removed). <br /><br />
        <b-badge href="#"
          variant="info"
          class="mr-1"
          v-for="lemma in selectedLemmata"
          :key="'modal-22-' + lemma.id"
          @click="removeSelectedLemma(lemma)"
        >
          <span v-html="`${lemma.form} (${lemma.language_code})`"></span>
          <!-- <b-icon icon="trash" aria-hidden="true" class="ml-1"></b-icon> -->
        </b-badge>
      </b-modal>
    </div>

  </div>
</template>

<style scoped>
* >>> .nowrap {
  white-space: nowrap;
  font-family: 'Courier New', Courier, monospace;
  font-size: 13px;
}

.hcc-float {
  position: fixed;
  bottom: 15px;
  left: 20px;
  background-color: #bebebe9a;
  padding: 3px 8px 5px;
  border-radius: 3px;
}

* >>> table tbody tr.selected td {
  background-color: rgb(4 123 254 / 8%);
}

table.dataTable > thead .sorting_disabled:before,
table.dataTable > thead .sorting_disabled:after {
  content: '' !important;
}

* >>> table.dataTable tr td,
* >>> table.dataTable tr th {
  background-color: #fff;
}

* >>> table.dataTable tr th:nth-child(-n+4),
* >>> table.dataTable tr td:nth-child(-n+4){
  z-index: 1000 !important;
}

table.dataTable > tbody tr {
  cursor: pointer;
}

table tr.filtering th {
  padding-right: 0 !important;
}

* >>> table.dataTable tr td abr::before {
  content: "(";
}

* >>> table.dataTable tr td abr::after {
  content: ")";
}

* >>> table.dataTable tr td maj::before {
  content: "{";
}

* >>> table.dataTable tr td maj::after {
  content: "}";
}

* >>> table.dataTable th.sorting::before,
* >>> table.dataTable th.sorting::after {
  content: '' !important;
  display: none;
}
</style>

<script>
import LemmaSelect from "@/components/Lemma/LemmaSelect.vue"
import HCCAutocomplete from "@/components/Scripta/HCCAutocomplete.vue"
import config from '@/config.js'

import $ from 'jquery'

import 'datatables.net-bs4'
import 'datatables.net-bs4/css/dataTables.bootstrap4.css'
import 'datatables.net-fixedcolumns-bs4'
import 'datatables.net-plugins/pagination/input.js'
// import '@/utilities/datatables-pagination.js'
// import '@/utilities/datatables-pagination.css'

export default {
  name: "DMSOccurrencesTable",

  props: ["context", "type", "groupType", "viewOnly", "hcc", "colorBin", "groupColors"],

  components: {
    LemmaSelect,
    HCCAutocomplete,
  },

  data() {
    let trIndex = {}
    if (this.context && this.context.results){
      trIndex = Object.fromEntries(this.context.results.map(token => [token.token_id, 0]))
    }
    let columns = [
        { key: 'selected', name: '-' },
        { key: 'editionSigle', name: this.$t('DMSOccTableEdition'), sortable: true, searchable: true },
        { key: 'division', name: this.$t('DMSOccTableDivision'), sortable: true, searchable: true },
        { key: 'date', name: this.$t('DMSOccTableDate'), sortable: true, searchable: true },
        { key: 'redactor', name: this.$t('DMSOccTableScriptorium'), sortable: true, searchable: true },
        { key: 'languages', name: this.$t('DMSOccTableLanguage'), sortable: true, searchable: true },
        { key: 'scripta', name: this.$t('DMSOccTableScriptae'), sortable: true, searchable: true },
        { key: 'lemmas', name: this.$t('DMSOccTableLemmata'), sortable: true, searchable: true },
        { key: 'hccs', name: this.$t('DMSOccTableHCCs'), sortable: true, searchable: true },
        { key: 'left', name: this.$t('DMSOccTableLeft'), sortable: true, searchable: true },
        { key: 'form', name: this.$t('DMSOccTableForm'), sortable: true, searchable: true },
        { key: 'right', name: this.$t('DMSOccTableRight'), sortable: true, searchable: true },
        { key: 'lastTokenLeft', data: 'sortKey' },
      ]
    let columnDefs = [
      { targets: 9, orderData: [12] },
      { target: 12, visible: false }
    ]
    return {
      config: config,
      selectedTokensLemmas: [],
      selectedHCCs: {},
      selectedLemmata: {},
      trIndex: trIndex,
      timer: null,
      filters: Array(columns.length).fill(""),
      columns: columns,
      columnDefs: columnDefs,
    };
  },

  computed: {
    tableData() {
      let retval = []
      if (this.context && this.context.results) {
        retval = this.context.results.map(row => {
          let _document = row.document_id ? this.context.documents[row.document_id] : null
          let editionSigle = _document ? _document.sigle_legam : ''
          let date = _document ? _document.date : ''
          let languages = row.lang ? row.lang.join(",") : ''
          let lemmas = row.lemma_id ? row.lemma_id.map(lemma_id => {
            const lemma = (this.context.lemmata || {})[lemma_id]
            return lemma ? lemma.form : `[missing lemma: ${lemma_id}]`
          }) : []
          let hccs = row.hcc_id ? row.hcc_id.map(hcc_id => {
            const hcc = (this.context.hccs || {})[hcc_id]
            const display = hcc ? (hcc.shortname || hcc.code) : `[missing HCC: ${hcc_id}]`
            return display.replace(/\s+/g, '&nbsp;')
          }) : []
          return {
            editionSigle: editionSigle,
            documentId: row.document_id,
            date: date,
            division: row.division,
            redactor: _document && _document.scriptorium ? _document.scriptorium : '-',
            languages: languages,
            scripta: _document && _document.scripta ? _document.scripta : '-',
            lemmas: lemmas,
            hccs: hccs,
            left: row.left,
            lastTokenLeft: row.last_token_left,
            form: row.form,
            right: row.right,
            tokenId: row.token_id,
            bin: row.bin
          }
        })
      }
      return retval
    }
  },

  unmounted() {
    if (this.table) {
      this.table.destroy()
    }
  },

  mounted() {
    this.table = $('table#datatable-results').DataTable({
      language: {
        info: "_START_-_END_ of _TOTAL_",
        infoFiltered: " - filtered from _MAX_"
      },
      lengthMenu: [25, 50, 100, 200],
      dom: "rlpt<'row'<'col-sm-12 col-md-4'i><'col-sm-12 col-md-8'p>>",
      pageLength: 100,
      pagingType: "input",
      stateSave: true,
      scrollX: true,
      fixedHeader: true,
      fixedColumns:   {
        left: 4,
      },
      createdRow: function (row, data) {
        $(row).attr("data-id", data.tokenId);
      },
      data: this.tableData,
      columns: this.columns.map(column => {
        return {
          data: column.key,
          defaultContent: '',
          orderable: (column.sortable === true ? true : false),
          render: (data, type, row) => {
              if (column.key == "editionSigle") {
              const route = this.$router.resolve({
                  name: 'DocumentDetails',
                  params: {
                    id: row.documentId,
                  },
                  query: {
                    tokenId: row.tokenId
                  }
                })
                return `<a href="${route.href}" target="_blank">${data}</a>`;
              } else {
                return data
              }
            },
          createdCell: (td, cellData, row, rowIndex, colIndex) => {
            if (this.groupColors) td.style.setProperty('background-color', this.groupColors[row.bin] + 'B0')

            if (this.columns[colIndex].key == "selected") {
              // pointer-events: none bc click event is handled by row
              if (this.selectedTokensLemmas.includes(row.tokenId)) {
                td.innerHTML = '<label style="pointer-events: none"><input type="checkbox" class="selectBox" checked></label>'
              } else {
                td.innerHTML = '<label style="pointer-events: none"><input type="checkbox" class="selectBox"></label>'
              }
            } else if ("form" == this.columns[colIndex].key) {
              td.innerHTML = `<span class="nowrap text-bold">${this.sanitizeTokenMarkup(cellData)}</span>`
              td.style.setProperty('text-align', 'center')
            } else if (["left", "right"].includes(this.columns[colIndex].key)) {
              td.innerHTML = `<span class="nowrap">${this.sanitizeTokenMarkup(cellData)}</span>`
              td.querySelectorAll('punct[original]').forEach(el => {
                el.textContent = el.getAttribute('original');
              });
              if ("left" == this.columns[colIndex].key) {
                td.style.setProperty('text-align', 'end')
              }
            }
          }
        }
      }),
      columnDefs: this.columnDefs,
    })

    let that  = this;

    $("table tbody").on("click", "tr", function () {
      let clickedRow = this
      let checkBox = clickedRow.querySelector('.selectBox')
      checkBox.checked ? checkBox.checked = false : checkBox.checked = true
      let rowData = that.table.row(clickedRow).data()

      if (that.selectedTokensLemmas.includes(rowData.tokenId)){
        that.selectedTokensLemmas = that.selectedTokensLemmas.filter(_tokenId => _tokenId != rowData.tokenId)
      }
      else {
        that.selectedTokensLemmas.push(rowData.tokenId)
      }

      // brute force: clear selected HCCs and rebuild from array containing only (duplicated) hcc_ids
      that.recomputeSelectedEntities()
    });
  },

  created() {
    // Remove selected row not in results
    if (this.context && this.context.results){
      this.filters = Array(this.columns.length).fill("")
      let tokenIds = null
      if (this.context.results) {
        tokenIds = this.context.results.map(token => token.token_id)
      }
      this.selectedTokensLemmas = this.$store.state.docediting.selectedTokensLemmas
      this.$store.state.docediting.selectedTokensLemmas = this.$store.state.docediting.selectedTokensLemmas.filter(
        tokenId => tokenIds.includes(tokenId)
      )
    }
  },

  watch: {
    selectedTokensLemmas() {
      this.$store.state.docediting.selectedTokensLemmas = this.selectedTokensLemmas
    },
    filters() {
      this.filterDataTablesData()
    }
  },
  methods: {
    sanitizeTokenMarkup(value) {
      const container = document.createElement('div')
      container.textContent = String(value == null ? '' : value)
      const encoded = container.innerHTML
      const parsed = document.createElement('div')
      parsed.innerHTML = encoded
        .replace(/&lt;(\/?)(punct|num|abr|maj)((?:(?!&gt;).)*)&gt;/gi, '<$1$2$3>')
      const allowedTags = new Set(['PUNCT', 'NUM', 'ABR', 'MAJ'])
      parsed.querySelectorAll('*').forEach(element => {
        if (!allowedTags.has(element.tagName)) {
          element.replaceWith(document.createTextNode(element.textContent))
          return
        }
        Array.from(element.attributes).forEach(attribute => {
          if (element.tagName !== 'PUNCT' || attribute.name !== 'original') {
            element.removeAttribute(attribute.name)
          }
        })
      })
      return parsed.innerHTML
    },
    filterDataTablesData() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.table) {
          this.filters.forEach((filter, index) => {
            if (this.table.column(index).search() !== filter) {
              this.table.column(index).search(filter, true, false);
            }
          });
          this.table.draw();
        }
      }, 500);
    },
    toCSV(table) {
      return table
        .map(row => row.map(cell => {
            // We remove blanks and check if the column contains
            // other whitespace,`,` or `"`.
            // In that case, we need to quote the column.
            cell = cell ? cell.toString().replace(/#/g, ".") : ''
            if (cell.replace(/ /g, '').match(/[\s,"]/)) {
                return '"' + cell.replace(/"/g, '""') + '"';
            }
            return cell;
          }).join(',')
        )
        .join('\n');
    },
    downloadCsvSelected() {
      const rows = [
        ["Edition", "Division", "Date", "Redactor", "Language", "Scripta", "Lemmas", "HCCs", "Form", "Left Context", "Right Context"],
        ...this.tableData.filter(row => this.selectedTokensLemmas.includes(row.tokenId)).map(row => [
          row.editionSigle,
          row.division,
          row.date,
          row.redactor,
          row.languages,
          row.scripta,
          row.lemmas,
          Object.values(row.hccs).map(hcc => hcc.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ')).join('; '),
          row.form,
          row.left,
          row.right
        ])
      ]

      // let csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join("\t")).join("\n");
      let csvContent = "data:text/csv;charset=utf-8," + this.toCSV(rows);
      let encodedUri = encodeURI(csvContent);
      let filename = `gallrom_export_${(new Date()).toISOString()}.csv`;
      let link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    },
    selectClass(tokenId) {
      let retval = []
      if (this.selectedTokensLemmas.includes(tokenId)){
        retval.push("selected")
      }
      return retval
    },
    redrawTable() {
      this.table.clear()
      this.table.rows.add(this.tableData);
      this.table.draw('full-hold');
    },
    selectAll() {
      this.$bvModal.msgBoxConfirm('Select all applies to all occurrences of the research, even those which are not currently visible in the table. Do you want to select everything?').then(value => {
        if (value) {
          this.selectedTokensLemmas = this.context.results.map(token => token.token_id)
          this.recomputeSelectedEntities()
          this.redrawTable()
        }
      })
    },
    deselectAll() {
      this.$bvModal.msgBoxConfirm('Deselect all applies to all selected occurrences of the research, even those which are not currently visible in the table. Do you want to deselect everything?').then(value => {
        if (value) {
          this.selectedTokensLemmas = []
          this.recomputeSelectedEntities()
          this.redrawTable()
        }
      })
    },
    biselectVisible(mode) {
      let deselect = mode == "deselect"
      let rows = this.table.rows( {page:'current'} ).data()

      if (deselect) {
        rows.map(row => {if (this.selectedTokensLemmas.includes(row.tokenId)) {
          this.selectedTokensLemmas = this.selectedTokensLemmas.filter(_tokenId => _tokenId != row.tokenId)
        }})
      } else {
        rows.map(row => {if (! this.selectedTokensLemmas.includes(row.tokenId)) {
          this.selectedTokensLemmas.push(row.tokenId)
        }})
      }

      this.recomputeSelectedEntities()
      this.redrawTable()
    },
    recomputeSelectedEntities() {
      this.selectedHCCs    = {}
      this.selectedLemmata = {}

      this.selectedTokensLemmas.forEach(tid => {
        const row = this.context.results.find(x => x.token_id == tid)
        if (row.lemma_id && row.lemma_id.length > 0) row.lemma_id.forEach(lemma =>
          this.selectedLemmata[lemma] = {...this.context.lemmata[lemma], id: lemma}
        )
        if (row.hcc_id && row.hcc_id.length > 0) row.hcc_id.forEach(hcc =>
          this.selectedHCCs[hcc] = {...this.context.hccs[hcc], id: hcc}
        )
      })
	},
    removeLemma() {
      this.$bvModal.msgBoxConfirm('Are you sure?').then(value => {
        if (value){
          this.$store.dispatch("removeAssignedLemmas", {
            tokenIds: this.selectedTokensLemmas,
            lemmaIds: this.selectedLemmata,
          }).then(() => {
            this.selectedTokensLemmas = []
            this.$emit('update')
          });
        }
      });
    },
    removeTag() {
      this.$bvModal.msgBoxConfirm('Are you sure?').then(value => {
        if (value){
          this.$store.dispatch("removeAssignedHCCs", {
            tokenIds: this.selectedTokensLemmas,
            hccIds: Object.keys(this.selectedHCCs),
          }).then(() => {
            this.selectedTokensLemmas = []
            this.selectedHCCs = {}
            this.$emit('update')
          });
        }
      });
    },
    removeSelected(item) {
      this.selectedHCCs = Object.fromEntries(Object.entries(this.selectedHCCs)
                                                .filter(_item => item.hcc_id != _item[0]))
    },
    removeSelectedLemma(item) {
      this.selectedLemmata = Object.fromEntries(Object.entries(this.selectedLemmata)
                                                .filter(_item => item.id != _item[0]))
    },
    assignTokensToLemma() {
      if (this.$refs.lemmaSelectRef.lemmaObj){
        this.$store.dispatch("assignTokensToLemma", {
          tokenIds: this.selectedTokensLemmas,
          lemmaId: this.$refs.lemmaSelectRef.lemmaObj.id,
        }).then(() => {
          this.$emit('update')
        });
      }
    },
    assignTokensToHCC() {
      if (this.$refs.hccRef.hccObj){
        this.$store.dispatch("assignTokensToHCC", {
          tokenIds: this.selectedTokensLemmas,
          hccId: this.$refs.hccRef.hccObj.id
        }).then(() => {
          this.selectedTokensLemmas = []
          this.$store.dispatch('addNotification', {
            type: 'success',
            text: `Tokens assigned to HCC`
          })
          this.$emit('update')
        });
      }
    },
    replaceHCC() {
      if (this.$refs.hccRefReplace.hccObj){
        this.$store.dispatch("replaceHCC", {
          tokenIds: this.selectedTokensLemmas,
          oldHccId: this.hcc.id,
          hccId: this.$refs.hccRefReplace.hccObj.id
        }).then(() => {
          this.selectedTokensLemmas = []
          this.$store.dispatch('addNotification', {
            type: 'success',
            text: `Tokens moved to new HCC`
          })
          this.$emit('update')
        });
      }
    },
  },
};
</script>
